// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"476":"7940c20f67c7cb23","496":"46dbb6c71b51853d","973":"f95a1f6aeca2c3fd"}[chunkId] + ".js";
};